import Caption from '@zenbusiness/common-components/Caption';
import Title from '@zenbusiness/common-components/Title';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import { useBreakpoints } from '#client/pages/EducationStudio/hooks/useBreakpoints';

import { useStyles } from './useStyles';

export const MAX_CHARACTER_COUNT = 75;
export const LARGER_MAX_CHARACTER_COUNT = 140;

export const ExercisePage = ({
  caption,
  title,
  summary,
  presentation,
  buttonText,
  isButtonDisabled,
  onNext,
  children
}) => {
  const {
    sizes: { isMobile }
  } = useBreakpoints();
  const classes = useStyles();

  return (
    <Grid className={classes.container} container>
      {!isMobile && (
      <Grid item xs={12} sm={6} className={classes.gridItem}>
        {presentation}
      </Grid>
      )}
      <Grid item xs={12} sm={6} className={classes.gridItem}>
        <Caption size="md" bold className={classes.caption}>{caption}</Caption>
        <Title variant={isMobile ? 'lg-alt' : 'md-alt'} className={classes.title}>
          {title}
        </Title>
        {summary}
        {isMobile && presentation}
        {children}
      </Grid>
      {isMobile && (
        <Grid item xs={12} className={classes.gridItem}>
          <Button
            className={classes.nextButton}
            variant="contained"
            color="primary"
            size="medium"
            disabled={isButtonDisabled}
            onClick={() => onNext()}
          >
            {buttonText}
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

ExercisePage.propTypes = {
  caption: PropTypes.string,
  title: PropTypes.string,
  summary: PropTypes.node,
  presentation: PropTypes.node.isRequired,
  buttonText: PropTypes.string,
  isButtonDisabled: PropTypes.bool,
  onNext: PropTypes.func
};

ExercisePage.defaultProps = {
  caption: '',
  title: '',
  summary: null,
  buttonText: '',
  isButtonDisabled: false,
  onNext: () => {}
};
